import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { useEntitiesContext } from 'entities/EntitiesExport'

const AuthLayout = observer(() => {
  const { usersStore } = useEntitiesContext()
  const { role } = usersStore.user || {}

  if (!role) return null

  return <Outlet />
})

export default AuthLayout
